import { toast } from "sonner";

// Download a base64 data-URL PNG as a clean file (not a page screenshot).
export const downloadQR = (dataUrl, filename = "qr.png") => {
  if (!dataUrl) { toast.error("QR non disponibile"); return; }
  const a = document.createElement("a");
  a.href = dataUrl;
  a.download = filename.endsWith(".png") ? filename : `${filename}.png`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  toast.success("QR scaricato");
};

export const copyLink = async (url) => {
  try {
    await navigator.clipboard.writeText(url);
    toast.success("Link copiato");
  } catch {
    toast.error("Impossibile copiare il link");
  }
};
